module.exports = __webpack_public_path__ + "assets/img/hot-search.fe113cb5.png";